import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#debt-consolidation-app', App);
